import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ScrollToTopOnNavigate />
    <MagellanPageView />
    <App />
  </Router>
);
reportWebVitals();

function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}

// Magellan AI Pixel - fire a page view on each client-side route change.
// The initial landing view is fired by the static snippet in public/index.html,
// so we skip the first render here to avoid double-counting it.
function MagellanPageView() {
  const { pathname } = useLocation();
  const firstRender = React.useRef(true);
  React.useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (window.MAI) window.MAI.emit('view');
  }, [pathname]);
  return null;
}
